/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary List service functions
 */

export const listServiceFunctionsQueryPerPageMax = 100;

export const listServiceFunctionsQueryStateDefault = `ACTIVE`;
export const listServiceFunctionsQuerySortKeyDefault = `serviceFunctionId`;

export const ListServiceFunctionsQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listServiceFunctionsQueryPerPageMax)
    .describe("Number of items per page"),
  q: zod.coerce
    .string()
    .optional()
    .describe("Case-insensitive substring search across Service Function code or name"),
  state: zod
    .enum(["ACTIVE", "DELETED", "ALL"])
    .default(listServiceFunctionsQueryStateDefault)
    .describe("Service Function state filter"),
  sortKey: zod
    .enum(["serviceFunctionId", "code", "name"])
    .default(listServiceFunctionsQuerySortKeyDefault)
    .describe("Service Function sort key"),
  sortDir: zod.enum(["asc", "desc"]).optional().describe("Sort direction"),
});

export const listServiceFunctionsResponseMetaTotalMin = 0;

export const ListServiceFunctionsResponse = zod.object({
  items: zod.array(
    zod.object({
      serviceFunctionId: zod.uuid().describe("Service Function identity."),
      state: zod.enum(["ACTIVE", "DELETED"]),
      createdAt: zod.iso.datetime({offset: true}),
      updatedAt: zod.iso.datetime({offset: true}),
      deletedAt: zod.iso.datetime({offset: true}).nullable(),
      code: zod.string(),
      name: zod.string(),
      description: zod.string(),
    }),
  ),
  meta: zod
    .object({
      total: zod
        .int()
        .min(listServiceFunctionsResponseMetaTotalMin)
        .describe("Total matching items."),
      page: zod.int().min(1).describe("Current 1-indexed page."),
      perPage: zod.int().min(1).describe("Requested items per page."),
    })
    .describe("Metadata for a paginated collection."),
});

/**
 * @summary Create service function
 */
export const CreateServiceFunctionBody = zod.object({
  code: zod.string(),
  name: zod.string(),
  description: zod.string(),
});

export const CreateServiceFunctionResponse = zod.uuid().describe("Service Function identity.");

/**
 * @summary Get service function
 */
export const getServiceFunctionQueryIncludeDeletedDefault = false;

export const GetServiceFunctionQueryParams = zod.object({
  includeDeleted: zod.boolean().default(getServiceFunctionQueryIncludeDeletedDefault),
});

export const GetServiceFunctionResponse = zod.object({
  serviceFunctionId: zod.uuid().describe("Service Function identity."),
  state: zod.enum(["ACTIVE", "DELETED"]),
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  deletedAt: zod.iso.datetime({offset: true}).nullable(),
  code: zod.string(),
  name: zod.string(),
  description: zod.string(),
});

/**
 * @summary Update service function
 */
export const UpdateServiceFunctionBody = zod.object({
  code: zod.string(),
  name: zod.string(),
  description: zod.string(),
});

export const UpdateServiceFunctionResponse = zod.void();

/**
 * @summary Delete service function
 */
export const DeleteServiceFunctionResponse = zod.void();

/**
 * @summary Restore service function
 */
export const RestoreServiceFunctionResponse = zod.void();
